<template>
    <div>
        <div class="flex center-xs space-top-1 space-bottom-2">
            <div class="vertical-center input-container">
                <div class="start-xs full-width">
                    <label for="phone">{{ step.label }}</label>
                    <input
                        @keyup.enter="keycheck"
                        v-model.trim="inputData"
                        v-focus
                        class="full-width"
                        type="tel"
                        :placeholder="step.placeholder"
                    />
                    <div v-if="inputValid" class="valid-check"></div>
                </div>
                <div class="full-width">
                    <div v-if="displayErrorMessage" class="red-text space-top-2">
                        {{step.errorMessage}}
                    </div>
                </div>
            </div>
        </div>
        <GDPRCheck
          v-if="step.gdprAgreement"
          :agreement="step.gdprAgreement"
          :notice="step.gdprPrivacyOptOut"
          v-model="GDPRChecked"
        />
        <ButtonSection
          :inputValid="inputValid"
          :order="order"
          :buttonText="step.buttonText"
          v-on:progress="verifyAndProgress()"
          v-on:back="$emit('back')"
        />
    </div>
</template>

<script>
import axios from 'axios';
import debounce from 'lodash.debounce';
import { required } from 'vuelidate/lib/validators';

import ButtonSection from '../components/ButtonSection';
import GDPRCheck from '../components/GDPRCheck';

const validPhone = (value) => /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/.test(value);

export default {
    props: ['step', 'order'],
    components: {
        ButtonSection,
        GDPRCheck
    },
    directives: {
        focus: {
            // directive definition
            inserted: function (el) {
                el.focus()
            }
        }
    },
    data() {
      return {
        dirty: false,
        GDPRChecked: false
      }
    },
    validations: {
        inputData: {
            required,
            validPhone (value) {
                return this.isValidInput(value)
            },
            uniqueCharacterLimit (value) {
                return this.countUniqueCharacters(value) > 3;
            }
        }
    },
    computed: {
        inputData: {
            get: function() {
                return this.$store.state.formFields[this.step.name];
            },
            set: debounce(function(value) {
                this.dirty = true;
                const name = this.step.name;
                this.$store.commit('updateField', { name, value })
            }, 600)
        },
        inputValid() {
          if (this.step.gdprAgreement) {
            return !this.$v.inputData.$invalid && this.GDPRChecked;
          }
          return !this.$v.inputData.$invalid;
        },
        displayErrorMessage() {
            return this.$v.inputData.$invalid && this.dirty;
        }
    },
    methods: {
        countUniqueCharacters(characters) {
            return characters.split('').filter(function(item, i, ar){ return ar.indexOf(item) === i; }).join('').length;
        },
        isValidInput(value) {
            const numWithoutSpaces = value.replace(/\s/g, '');

            return /^\s*(?:\+?(\d{1,3}))?[-. (]*(\d{3})[-. )]*(\d{3})[-. ]*(\d{4})(?: *x(\d+))?\s*$/.test(numWithoutSpaces);
        },
        async verifyAndProgress() {
            this.verifyPhone();
            this.$emit('progress',this.step.name);
        },
        async verifyPhone() {
            try {
                const response = await axios({
                    method: 'post',
                    url: '/validate',
                    headers: {
                        'Content-type': 'application/json'
                    },
                    data: {
                        inputToValidate: 'phone',
                        phone: this.$store.state.formFields[this.step.name]
                    }
                })
                if(response.status === 200) {
                    const phoneValid = response.data.valid ? response.data.valid : '';
                    const phoneType = response.data.line_type ? response.data.line_type : '';
                    this.$store.commit('phoneValid', phoneValid);
                    this.$store.commit('phoneType', phoneType);
                }
            } catch(e) {
                console.error("Phone verification failed.");
            }
        },
        keycheck(e) {
            if (e.keyCode === 13 && this.inputValid) {
                this.$emit('progress', this.step.name );
            }
        }
    }
}
</script>

<style lang="scss" scoped>
input[type=tel] {
    border: 3px solid #0384FB;
    box-sizing: border-box;
}
</style>